import { put, select, takeEvery } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { SAVE_LOG_SUCCESS } from './log';
import { workoutDayFromDate } from './workouts';

export const CLOSE_MODAL = 'completed/CLOSE_MODAL';
export const OPEN_MODAL = 'completed/OPEN_MODAL';
export const CLOSE_NEW_SIGNUP_MODAL = 'completed/CLOSE_NEW_SIGNUP_MODAL';
export const OPEN_NEW_SIGNUP_MODAL = 'completed/OPEN_NEW_SIGNUP_MODAL';


export function newSignupOpen(state = false, action) {
    switch (action.type) {
        case OPEN_NEW_SIGNUP_MODAL:
            return true;
        case CLOSE_NEW_SIGNUP_MODAL:
            return false;
        default:
            return state;
    }
}

export function congrats(state = { open: false }, action) {
    switch (action.type) {
        case OPEN_MODAL:
            return {
                open: true,
                success: action.log.log_goalrace === 'Finished',
            };
        case CLOSE_MODAL:
            return { open: false };
        default:
            return state;
    }
}

export default combineReducers({
    congrats,
    newSignupOpen,
});

export const closeModal = finished => ({
    type: CLOSE_MODAL,
    finished,
});

export const openModal = log => ({
    type: OPEN_MODAL,
    log,
});

export const openNewSignupModal = () => ({
    type: OPEN_NEW_SIGNUP_MODAL,
});

export const closeNewSignupModal = () => ({
    type: CLOSE_NEW_SIGNUP_MODAL,
});

export function* openModalSaga({ log }) {
    if (log.log_id) {
        // ignore it's edit
        return;
    }
    const { race } = yield select();
    const totalWorkouts = race.info.plan_week * 7;
    const treningDay = workoutDayFromDate({
        date: log.date,
        totalWorkouts,
        raceDate: race.info.race_date,
    });
    if (totalWorkouts === treningDay) {
        yield put(openModal(log));
    }
}

export function* rootSaga() {
    yield takeEvery(SAVE_LOG_SUCCESS, openModalSaga);
}



/** WEBPACK FOOTER **
 ** ./src/redux/completed.js
 **/